import { render, staticRenderFns } from "./userRecoard.vue?vue&type=template&id=5d67daa6&scoped=true&"
import script from "./userRecoard.vue?vue&type=script&lang=js&"
export * from "./userRecoard.vue?vue&type=script&lang=js&"
import style0 from "./userRecoard.vue?vue&type=style&index=0&id=5d67daa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67daa6",
  null
  
)

export default component.exports